import { FC, ReactNode, useCallback } from 'react';
import { StoreFilled } from '@weee-fe/kunlunicon';

import DropDownStatic from '@/components/common/EnkiDummyUI/DropDownStatic';
import { DrawerType } from '@/components/homepage/components/Header/types';
import Constants from '@/constants/const';
import { useOpenGlobalNavHeaderDrawer } from '@/hooks/globalnavheader/GlobalNavHeaderDrawerContext';
import { useMergedGlobalStoreInfo } from '@/hooks/globalnavheader/useMergedGlobalStoreInfo';

const NavStoreName: FC = () => {
  const { langMayHaveStore, showStore, selectStoreName, lang } = useMergedGlobalStoreInfo();
  const openGlobalNavHeaderDrawer = useOpenGlobalNavHeaderDrawer();

  const onStoreClick = useCallback(() => {
    openGlobalNavHeaderDrawer(DrawerType.store, true);
  }, [openGlobalNavHeaderDrawer]);

  if (!langMayHaveStore || !showStore) {
    return null;
  }

  let label: string | ReactNode;
  if (selectStoreName) {
    const lowerName = selectStoreName.toLowerCase();
    if (lang === Constants.LANGUAGE_EN) {
      label = lowerName.endsWith(' store') ? selectStoreName : `${selectStoreName} store`;
    } else if (lang === Constants.LANGUAGE_ES) {
      label = lowerName.startsWith('tienda ') ? selectStoreName : `Tienda ${lowerName}`;
    } else {
      label = selectStoreName;
    }
  } else {
    label = <span className="skeleton bg-surface-200-bg w-[82px] h-[11px] rounded-100"></span>;
  }

  return (
    <DropDownStatic
      onClick={onStoreClick}
      mainIcon={<StoreFilled width={11} height={11} className="text-primary-1 -ml-1" />}
      dataTestId="wid-modal-store"
      label={label}
      mainColorTwNotation={'text-primary-1 enki-body-3xs-medium'}
      wrapperClassName="justify-center px-1.5"
      hideCarat={false}
    />
  );
};

export default NavStoreName;
